var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalculator = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 73.33 90.94",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3cf;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-2 {\n        fill: #252544;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.42,
    dy: 1.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.42
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#081221",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.58 9.11 61.77 2.5 54.94 0 10.57 0 0 10.57 0 80.37 10.57 90.94 62.75 90.94 73.33 80.37 73.33 17.18 69.58 9.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.94,11.33H10.57s0,69.8,0,69.8h52.18s0-63.19,0-63.19l-7.81-6.61ZM60.89,79.26H12.44s0-66.07,0-66.07h41.82s6.63,5.61,6.63,5.61v60.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.45,32.64h40.43s0-13.53,0-13.53H16.45s0,13.53,0,13.53ZM18.31,20.97h36.7s0,9.8,0,9.8H18.31s0-9.8,0-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,46.46h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM18.67,38.6h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.8,46.46h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM33.67,38.6h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,60.28h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM18.67,52.42h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.8,60.28h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM33.67,52.42h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,74.1h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM18.67,66.24h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.8,74.1h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM33.67,66.24h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.8,46.46h9.72s0-9.72,0-9.72h-9.72s0,9.72,0,9.72ZM48.67,38.6h5.99v5.99h-5.99v-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.8,74.1h9.72s0-23.54,0-23.54h-9.72s0,23.54,0,23.54ZM48.67,52.42h5.99s0,19.81,0,19.81h-5.99s0-19.81,0-19.81Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalculator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calculator.293d016f00d93d28f63234781bc783a7.svg";